import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    description?: string;
    children?: ReactNode; // Right-side actions
    className?: string;
}

export function PageHeader({ title, description, children, className }: PageHeaderProps) {
    return (
        <div
            className={cn(
                'flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between mb-6',
                !children && 'hidden md:flex',
                className
            )}
        >
            <div className="min-w-0 hidden md:block">
                <h1 className="text-xl sm:text-2xl font-bold text-foreground tracking-tight">{title}</h1>
                {description && (
                    <p className="text-sm text-muted-foreground mt-1">{description}</p>
                )}
            </div>
            {children && (
                <div className="flex items-center gap-2 shrink-0 flex-wrap">
                    {children}
                </div>
            )}
        </div>
    );
}
